import { NavLink } from "react-router-dom";
import "./Servicepolicies.css";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useEffect, useState, useRef } from "react";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet';


const ServicesHead = () => {
    const [metaData, setMetaData] = useState({
        urlSlug: '',
        titleTag: '',
        metaDescription: '',
        markupName: '',
        jsonLdMarkup: '',
        ogTitle: '',
        ogDescription: '',
        ogImage: '',
    });

    const [jsonData, setJsonData] = useState(null);

    const fetchSeoData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PROD_URL}/seo-settings/seo005`);
            if (response.ok) {
                const result = await response.json();
                const data = result.data;
                setMetaData({
                    urlSlug: data.urlSlug || '',
                    titleTag: data.titleTag || '',
                    metaDescription: data.metaDescription || '',
                    markupName: data.markupName || '',
                    jsonLdMarkup: data.jsonLdMarkup || '',
                    ogTitle: data.ogTitle || '',
                    ogDescription: data.ogDescription || '',
                    ogImage: data.ogImage || '',
                });

                const jsonObjects = JSON.parse(`[${data.jsonLdMarkup}]`);

                setJsonData(jsonObjects);
            }
        } catch (error) {

        }

    };

    useEffect(() => {
        fetchSeoData();
    }, [])
    return (
        <>
            <Helmet>
                {/* Dynamically setting title, meta, and Open Graph tags */}
                <title>{metaData.titleTag}</title>
                <meta name="description" content={metaData.metaDescription} />
                <link rel="canonical" href={metaData.urlSlug} />
                <meta property="og:title" content={metaData.ogTitle} />
                <meta property="og:site_name" content="Colorbot" />
                <meta property="og:url" content={metaData.urlSlug} />
                <meta property="og:description" content={metaData.ogDescription} />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={metaData.ogImage} />


                {/* Dynamically include JSON-LD markup */}

                {jsonData && jsonData.map((data, index) => (

                    <script type="application/ld+json" key={index}>
                        {JSON.stringify(data)}
                    </script>
                ))}
            </Helmet>

            {/* <Helmet>
        <title>Services and Policies</title>
        <meta name="description" content="Discover Colorbot Services and Policies, including our dedication to customer satisfaction, product warranties, and support guidelines for seamless experience." />
        <link rel="canonical" href="https://colorbot.in/services-policies" />

        <meta property="og:title" content="Services and Policies" />
        <meta property="og:site_name" content="Colorbot" />
        <meta property="og:url" content="https://colorbot.in/services-policies" />
        <meta property="og:description" content="Discover Colorbot Services and Policies, including our dedication to customer satisfaction, product warranties, and support guidelines for seamless experience." />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://colorbots3.s3.ap-south-1.amazonaws.com/banners/Services-banner.jpg" />
    </Helmet> */}
        </>
    )

};

function Servicepolicies() {
    useEffect(() => {
        window.scrollTo(0, 0)

    }, [])



    let currentDate = new Date();

    // Subtract 30 days from the current date
    let thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(currentDate.getDate() - 30);
    const today = new Date().toISOString().split('T')[0];
    // Format the warranty date as a string (YYYY-MM-DD)
    let warrantyDate = thirtyDaysAgo.toISOString().split('T')[0];
    const fileInputRef = useRef(null);
    const [filename, setfilename] = useState("")
    const handleButtonClick = () => {
        setfilename("")
        fileInputRef.current.click();
    };
    const [name, setName] = useState('');
    const [file, setFile] = useState(null);

    const [serial, setSerial] = useState('');
    const [modal, setModal] = useState('');
    const [platform, setPlatform] = useState('');
    const [date, setDate] = useState('');
    const [invoice, setInvoice] = useState('');
    const [itemNo, setItemNo] = useState('');
    const [description, setDescription] = useState('');
    const [address, setAddress] = useState('');

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        // Do something with the selected file (e.g., upload, read contents, etc.)

        setfilename(selectedFile.name)
    };
    const [lgShow, setLgShow] = useState(false);

    function warrantypop() {
        setLgShow(true)
    }
    const h3RefRegister = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [isH3Visible, setIsH3Visible] = useState(false);


    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [warrantypolicy, setwarrantypolicy] = useState(false)
    const [active, setactive] = useState(false)
    const [lgShow1, setLgShow1] = useState(false);

    const handlePhoneChange = (e) => {
        const inputValue = e.target.value;
        setPhoneNumber(inputValue);

    };

    const handleEmailChange = (e) => {
        const inputValue = e.target.value;
        setEmail(inputValue);

    };



    const handleSubmit = async () => {


        const phoneRegex = /^\d{10}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (name === "") {
            toast.error("Please enter your name.")
        } else if (phoneNumber === "") {
            toast.error("Please enter your phone number.")
        } else if (!phoneRegex.test(phoneNumber)) {
            toast.error("Please enter a valid 10 digit Phone Number")
        } else if (email === "") {
            toast.error("Please enter your email address.")
        } else if (!emailRegex.test(email)) {
            toast.error("Please enter a valid email address.")

        } else if (serial === "") {
            toast.error("Please enter your product order Id.")
        } else if (modal === "") {
            toast.error("Please select your product modal.")
        } else if (itemNo === "") {
            toast.error("Please enter your product item no.")
        } else if (platform === "") {
            toast.error("Please select your product platform.")
        } else if (date === "") {
            toast.error("Please select your product purchase date.")
        } else if (filename === "") {
            toast.error("Please upload your product invoice.")
        }
        else {

            setactive(true)
            try {

                const formData = new FormData();
                formData.append('name', name);
                formData.append('email', email);
                formData.append('phone', phoneNumber);
                formData.append('address', address);
                formData.append('modal', modal);
                formData.append('orderid', serial);
                formData.append('date', date);
                formData.append('itemno', itemNo);
                formData.append('platform', platform);
                formData.append('file', file);
                formData.append('description', description);

                await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotRegisterWarrantyClaim`, {
                    method: 'POST',
                    body: formData
                }).then((res) => res.json()).then((response) => {


                    if (response.status === 200) {
                        setactive(false)
                        setLgShow1(true)
                        toast.success(response.message)
                        setName("")
                        setEmail("")
                        setPhoneNumber("")
                        setItemNo("")
                        setAddress("")
                        setModal("")
                        setSerial("")
                        setPlatform("")
                        setDate("")
                        setInvoice("")
                        setDescription("")
                        setfilename("")

                    } else {
                        setactive(false)
                        toast.error(response.error)
                    }
                })
            } catch (error) {
                setactive(false)
                console.log(error)
            }

        }


    };
    const [tab, setTab] = useState([

        {
            id: "vendor",
            name: "Distributor Policy"
        },
        {
            id: "shipping",
            name: "Shipping Policy"
        }, {
            id: "warranty",
            name: "Warranty Policy"
        },

        {
            id: "Payment",
            name: "Payment security"
        },
        {
            id: "Customer",
            name: "Customer grievance"
        },
        {
            id: "Register",
            name: "Register New Complaint"
        },

    ])
    const [activetab, setActivetab] = useState(tab[0].id)

    const [servicesData, setServicesData] = useState("")
    const fetchWebData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotCMSProductCategory/category005`);
            if (response.ok) {
                const result = await response.json();
                setServicesData(result.data)
            }
        } catch (error) {
            console.log(error)
        }

    };
    useEffect(() => {
        fetchWebData()
    }, [])
    return (
        <>
            <section className='mt-5 pt-4'>
                <ServicesHead />
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    style={{
                        borderRadius: "10px"
                    }}

                    centered
                    show={lgShow1}

                    onHide={() => setLgShow1(false)}

                >
                    <Modal.Header style={{ borderBottom: "none", padding: "1rem 1rem 0rem 0rem" }}>

                    </Modal.Header>
                    <Modal.Body style={{ paddingTop: "0rem" }}>


                        <div className="box-profile-pop-profile">



                            <div className="logoutpop">
                                <img src="assets/successicon.svg" className="img-fluid" alt="exlam" />
                            </div>
                            <div className="logoutpop mt-2">
                                <p>Thank You! Your Complaint has been registered successfully.</p>
                            </div>
                            <div className="logoutpop button">
                                <button className="btn btncancellog" style={{
                                    background: "#242933",
                                    padding: "6px 47px",
                                    color: "white",
                                    borderRadius: "8px"
                                }} onClick={() => setLgShow1(false)}>
                                    Ok
                                </button>

                            </div>







                        </div>


                    </Modal.Body>
                </Modal>


                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 padd-neg">
                            <div className="banner-img">
                                <LazyLoadImage src={"https://colorbots3.s3.ap-south-1.amazonaws.com/banners/Services-banner.jpg"}
                                    width={"100vw"}
                                    className="d-block w-100 img-fluid" alt="Services and Policies"
                                    effect="blur"
                                />

                            </div>
                        </div>
                    </div>
                </div>
                <div className="container p-5" >

                    <ul className="nav nav-tabs service-tab" id="myTab" role="tablist" >
                        {tab.map((item, index) => {
                            return (
                                <li className="nav-item" key={index}>
                                    <a className={`nav-link ${activetab === item.id ? "active" : ""}`} id={`${item.id}-tab`} data-toggle="tab" href={`#${item.id}`} role="tab" aria-controls={`${item.id}`} aria-selected="true" onClick={() => setActivetab(item.id)}>{item.name}</a>
                                </li>
                            )
                        })}

                    </ul>

                    <div className="tab-content" id="myTabContent">

                        {activetab === "vendor" ? (
                            <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="vendor-tab">
                                {/* id="vendor" */}
                                <div className="servicetab">
                                    <p>
                                        <span dangerouslySetInnerHTML={{ __html: servicesData?.editorContent }}></span>
                                        <br/>

                                        <NavLink to="https://docs.google.com/forms/d/1zNGMYmT_RadeXlR0qmexiFjEN7umeGGktIU4hzFF7ew/viewform?edit_requested=true" target="_blank"><button className="btn btn-primary">Become a Distributor</button></NavLink>

                                    </p>
                                </div>
                            </div>) : ("")}

                        {activetab === "shipping" ? (
                            <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="shipping-tab">
                                {/* id="shipping" */}
                                <div className="servicetab">
                                <span dangerouslySetInnerHTML={{ __html: servicesData?.editorContent1 }}></span>
                                </div>
                            </div>
                        ) : ("")}
                        {activetab === "warranty" ? (
                            <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="warranty-tab">
                                {/* id="warranty" */}
                                <div className="servicetab">
                                    <p>
                                    <span dangerouslySetInnerHTML={{ __html: servicesData?.editorContent2 }}></span>
                                    </p>


                                </div>
                            </div>) : ("")}


                        {activetab === "Payment" ? (
                            <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="Payment-tab">
                                {/* id="Payment" */}
                                <div className="servicetab">
                                    <p>
                                    <span dangerouslySetInnerHTML={{ __html: servicesData?.editorContent3 }}></span>
                                    </p>

                                </div>
                            </div>
                        ) : ("")}

                        {activetab === "Customer" ? (
                            <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="Customer-tab">
                                {/* id="Customer" */}
                                <div className="servicetab">
                                <span dangerouslySetInnerHTML={{ __html: servicesData?.editorContent4 }}></span>

                                </div>
                            </div>
                        ) : ("")}

                        {activetab === "Register" ? (
                            <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="Register-tab">
                                {/* id="Register" */}
                                <div className="servicetab">
                                    <div className="container-fluid ">
                                        <div className="row justify-content-center">

                                            <div className="col-lg-8">
                                                <div className="contact-usregister mt-4">

                                                    <input type="text" placeholder="Name*" className="form-control form-control-lg mt-4" value={name} onChange={(e) => {
                                                        setName(e.target.value)
                                                    }} />
                                                    <input
                                                        type="text"
                                                        placeholder="Phone*"
                                                        className="form-control form-control-lg mt-3"
                                                        value={phoneNumber}
                                                        onChange={handlePhoneChange}
                                                        minLength={10}
                                                        maxLength={10}

                                                    />

                                                    <input
                                                        type="email"
                                                        placeholder="Email*"
                                                        className="form-control form-control-lg mt-3"
                                                        value={email}
                                                        onChange={handleEmailChange}

                                                    />
                                                    <input
                                                        type="text"
                                                        placeholder="Address*"
                                                        className="form-control form-control-lg mt-3"
                                                        value={address}
                                                        onChange={(e) => {
                                                            setAddress(e.target.value)

                                                        }}

                                                    />
                                                    <input type="text" placeholder="Order ID*" className="form-control form-control-lg mt-3" value={serial} onChange={(e) => {
                                                        setSerial(e.target.value)
                                                    }} />
                                                    <select className="form-control form-control-lg mt-3" style={{
                                                        padding: "8px 25px",
                                                        color: "#6a6f73",

                                                        fontSize: "14px",
                                                        fontStyle: "normal",
                                                        fontWeight: "400",
                                                        lineHeight: "normal"

                                                    }} value={modal} onChange={(e) => {
                                                        setModal(e.target.value)

                                                    }}>
                                                        <option value={""}>Product Model</option>
                                                        <option value={"Helix"}>Helix</option>
                                                        <option value={"Stella"}>Stella</option>
                                                        <option value={"Prizma"}>Prizma</option>
                                                        <option value={"Knoxx"}>Knoxx</option>
                                                        <option value={"Knoxx-Quad"}>Knoxx Quad</option>
                                                        <option value={"Stella-Quad"}>Stella Quad</option>

                                                    </select>
                                                    <input type="text" placeholder="Item No*" className="form-control form-control-lg mt-3" value={itemNo} onChange={(e) => {
                                                        setItemNo(e.target.value)
                                                    }} />
                                                    <select className="form-control form-control-lg mt-3" style={{
                                                        padding: "8px 25px",
                                                        color: "#6a6f73",

                                                        fontSize: "14px",
                                                        fontStyle: "normal",
                                                        fontWeight: "400",
                                                        lineHeight: "normal"
                                                    }} value={platform} onChange={(e) => {
                                                        setPlatform(e.target.value)

                                                    }}>
                                                        <option value={""}>Platform</option>
                                                        <option value={"ColorBot"}>Colorbot Website</option>
                                                        <option value={"Amazon"}>Amazon</option>
                                                        <option value={"Flipkart"}>Flipkart</option>
                                                    </select>

                                                    <label className="mt-3" >Date of Purchase*</label>

                                                    <input type="date" className="form-control form-control-lg mt-1" max={today} min={warrantyDate} value={date} onChange={(e) => {
                                                        setDate(e.target.value)
                                                    }} />
                                                    <label className="mt-3">Upload Invoice</label>
                                                    <button className="btn-primary btn-upload mt-2" onClick={handleButtonClick}>
                                                        Choose File
                                                    </button> {filename}
                                                    <input
                                                        type="file"
                                                        ref={fileInputRef}
                                                        style={{ display: 'none' }}
                                                        onChange={handleFileChange}
                                                    />

                                                    <textarea className="form-control form-control-lg  mt-3" placeholder="Description*" value={description} onChange={(e) => {
                                                        setDescription(e.target.value)
                                                    }}></textarea>


                                                    <button className="btn btn-lg btn-primary mt-4 mb-4 contactsubmit" disabled={active} onClick={() => {
                                                        handleSubmit()
                                                    }}>SUBMIT</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : ("")}



                    </div>

                </div>
            </section>
        </>
    );

}
export default Servicepolicies;